// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";

// Material Kit 2 React components
import MKTypography from "components/MKTypography";

// Images
import logo from "assets/images/skyscraper.png";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "Centro Histórico de San Miguel",
    image: logo,
    route: "/",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: "https://www.facebook.com/ugboficial",
    },
    {
      icon: <TwitterIcon />,
      link: "https://twitter.com/UGB_SV",
    },
    {
      icon: <YouTubeIcon />,
      link: "https://www.youtube.com/user/VideosUGB",
    },
    {
      icon: <InstagramIcon />,
      link: "https://www.instagram.com/ugb.sv/",
    },
  ],
  menus: [
    {
      name: "Bienes Inmuebles",
      items: [
        { name: "Buscador de inmuebles", route: "/search" },
        { name: "Agregados recientemente", route: "/" },
        { name: "Más visitados", route: "/" },
      ],
    },
    {
      name: "Actividades económicas urbanas",
      items: [
        { name: "Identificación", href: "https://rpubs.com/VictorSandoval/910933" },
        {
          name: "Flujos vehiculares",
          href: "https://rpubs.com/VictorSandoval/910891",
        },
        {
          name: "Flujos peatonales",
          href: "https://rpubs.com/VictorSandoval/910896",
        },
      ],
    },
    {
      name: "Vendedores en la vía pública",
      items: [
        {
          name: "Ubicación",
          route: "/vendors/georeference",
        },
        {
          name: "Características Sociodemográficas",
          route: "/vendors/sociodemographics",
        },
        {
          name: "Características de los clientes VVP",
          route: "/clients/clientcharacteristics",
        },
      ],
    },
    {
      name: "Normativa y trámites",
      items: [
        { name: "Ley de Cultura", route: "/documentation/culture/law" },
        {
          name: "Ley especial de protección al patrimonio cultural de El Salvador",
          route: "/documentation/culture/speciallaw",
        },
        {
          name: "Formulario de permiso de construcción",
          route: "/documentation/forms/construction",
        },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      <MKTypography variant="button" fontWeight="regular" sx={{ color: "#344767" }}>
        Copyright &copy; {date} Universidad Gerardo Barrios
      </MKTypography>
    </MKTypography>
  ),
};
